module.exports = __webpack_public_path__ + "img/qr-code-ebadge.6fbdfb99.png";